import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { Button, MenuList, MenuItem, Popper, Grow, Paper, ClickAwayListener } from '@material-ui/core';
import DownArrowIcon from '@material-ui/icons/ArrowDropDown';
import Auth from '../../util/Auth';

const styles = () => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
    },
    appBar: {
        zIndex: 1201, // Above drawer
        backgroundColor: '#1976d2',
    },
    content: {
        flex: 1,
        overflow: 'auto',
        paddingTop: '8px',
    },
    grow: {
        flexGrow: 1,
    },
    title: {
        fontWeight: 'bold',
        fontSize: '1.2rem',
    },
});

class MobileDrawer extends React.Component {
    state = {
        menuAnchor: null,
    };

    handleMenuButtonClick = (e) => {
        this.setState({ menuAnchor: e.currentTarget });
    };

    handleMenuClose = () => {
        this.setState({ menuAnchor: null });
    };

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>
                <CssBaseline />
                <AppBar position="sticky" className={classes.appBar}>
                    <Toolbar>
                        <Typography variant="h6" color="inherit" className={classes.grow} noWrap>
                            <span className={classes.title}>LANDS</span>
                        </Typography>

                        <Button
                            variant="contained"
                            style={{ boxShadow: 'none' }}
                            onClick={this.handleMenuButtonClick}
                            aria-owns={this.state.menuAnchor ? 'menu-list-grow' : undefined}
                        >
                            Account <DownArrowIcon />
                        </Button>

                        <Popper
                            anchorEl={this.state.menuAnchor}
                            open={Boolean(this.state.menuAnchor)}
                            transition
                            disablePortal
                        >
                            {({ TransitionProps, placement }) => (
                                <Grow
                                    {...TransitionProps}
                                    style={{
                                        transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'
                                    }}
                                >
                                    <Paper>
                                        <ClickAwayListener onClickAway={this.handleMenuClose}>
                                            <MenuList>
                                                <MenuItem onClick={() => Auth.logout()}>Logout</MenuItem>
                                            </MenuList>
                                        </ClickAwayListener>
                                    </Paper>
                                </Grow>
                            )}
                        </Popper>
                    </Toolbar>
                </AppBar>

                <main className={classes.content}>
                    {React.cloneElement(this.props.children, { ...this.props })}
                </main>
            </div>
        );
    }
}

export default withStyles(styles)(MobileDrawer);